import { Controller } from "stimulus"

// Makes a table row (or header cell) navigate like a link. Clicks on real
// links inside the element still behave normally. Inside a turbo-frame the
// frame is navigated instead of the whole page, so scroll position is kept.
//
// Elements with data-range-value and data-range-param support shift-click:
// the current single selection (or the start of the current range) becomes
// the anchor and the clicked value the other end, e.g. ih_month=2026-10..2027-01.
export default class extends Controller {
  visit(event) {
    if (event.target.closest("a")) return

    const { href, rangeValue, rangeParam } = this.element.dataset

    if (event.shiftKey && rangeValue && rangeParam && rangeValue !== "none") {
      const url = new URL(window.location)
      const current = url.searchParams.get(rangeParam)
      const anchor = current ? current.split("..")[0] : rangeValue

      if (anchor !== "none") {
        const [from, to] = [anchor, rangeValue].sort()
        url.searchParams.set(rangeParam, from === to ? from : `${from}..${to}`)
        this.navigate(url.pathname + url.search)
        return
      }
    }

    this.navigate(href)
  }

  navigate(url) {
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.src = url
    } else {
      window.Turbo.visit(url)
    }
  }
}
